export const documentBuilderVariants = {
  SECTION: 'Section',
  DOCUMENT: 'Document',
}